export default __webpack_public_path__ + "static/media/price.21da3ff7.svg";